import React from 'react';
import { Popover as AntPopover } from 'antd';
import type { PopoverProps } from 'antd';
import clsx from 'clsx';

/**
 * Thin wrapper over the Antd Popover (per the antd wrapper standardization plan):
 * single import source through @common/components. `overlayClassName` is the
 * antd-side hook that lands on the floating panel, so we merge into that
 * instead of the trigger's `className`.
 */
export const Popover = ({ overlayClassName, ...props }: PopoverProps) => (
  <AntPopover
    {...props}
    overlayClassName={clsx('wk-popover', overlayClassName)}
  />
);
